<template>
  <div id="app" v-if="resume">
    <icons></icons>
    <basic-info :resume="resume" />
    <!-- <showcase /> -->
    <!-- <quotes :quotes="resume.quotes[0]" /> -->
    <footer>
      <h2>{{ router.lang === 'fr' ? 'Souhaitez-vous en savoir plus ?' : 'Want to know more?' }}</h2>
      <div>
        <a class="contact" v-bind:href="`${router.lang === 'fr' ? '/resume-fr.html' : '/resume.html'}`" target=_blank>{{ router.lang === 'fr' ? 'Résumé' : 'Resume' }}</a>
        <a class="contact" href="mailto:scott.b.mckay@protonmail.com">Contact</a>
      </div>
    </footer>
  </div>
</template>

<script>
import BasicInfo from './../components/BasicInfo.vue'
// import Quotes from './../components/Quotes.vue'
import Icons from './../core/Icons.vue'
// import Showcase from './../components/Showcase.vue'

export default {
  name: 'app',
  beforeCreate () {
    const browserLang = ((navigator || {}).language || '').split('-')[0]
    const currentLang = this.$router.history.current.params.lang
    const userLang = localStorage.getItem('lang')

    if ((currentLang !== browserLang) && !userLang) {
      this.$router.push({ name: 'home', params: { lang: browserLang } })
    }

    fetch('/resume.json').then(req => req.json())
      .then(data => {
        this.resume = data
        console.log('Here\'s my resume in JSON if you\'d like')
        console.log(JSON.parse(JSON.stringify(this.resume)))
      })
  },
  data: function () {
    return {
      resume: null,
      router: {
        lang: this.$router.history.current.params.lang || 'en'
      }
    }
  },
  watch: {
    $route: 'reRenderLanguage'
  },
  methods: {
    reRenderLanguage: function () {
      this.$set(this.router, 'lang', this.$router.history.current.params.lang)
    }
  },
  components: {
    BasicInfo,
    // Quotes,
    Icons
    // Showcase
  }
}
</script>

<style lang="postcss">
@import 'core/style-theme';

footer {
  padding: var(--spacingMd) 0;
  background-color: var(--colorPrimary);
  color: var(--colorDarkerGrey);
  text-align: center;

  & .contact
  {
    padding: 40px;
  }

  @media (--tablet) {
    padding: var(--spacingXL);
  }

  & h2 {
    @mixin header2;
    margin-top: 0;
    color: var(--colorDarkerGrey);
  }

  & div {
    @mixin body;
    font-size: 2rem;
    color: var(--colorDarkerGrey);

    & a {
      display: inline-block;
      text-align: center;
      color: var(--colorDarkerGrey);
    }
  }

}
</style>
